<ng-template #popTemplate>
  <button pbutton type="button" icon="pi pi-times" class="p-element p-button-rounded p-button-text p-button-plain btn-close p-button p-component p-button-icon-only" (click)="popHide($event)">
    <span class="p-button-icon pi pi-times" aria-hidden="true"></span><span aria-hidden="true" class="p-button-label">&nbsp;</span>
  </button>
  <div [innerHtml]="tooltipValue | safeHtml"></div>
</ng-template>
<div style="display: inline-block; white-space: nowrap" *ngIf="aideService.displayAide">
  <button
    type="button"
    class="btn btn-sm btn-link btn-view-aide"
    title="Consulter l'aide"
    [style.display]="tooltipValue || isAdminAide() ? 'inline-block' : 'none'"
    [style.cursor]="tooltipValue ? 'pointer' : 'default'"
    [outsideClick]="true"
    [popover]="popTemplate"
    container="body"
    [adaptivePosition]="adaptivePosition"
    [placement]="placement"
    containerClass="customClassAide"
    #pop="bs-popover"
    (click)="popClick($event)"
  >
    <span class="fa fa-question fa-question-circle-special" aria-hidden="true" [class.noTooltipValue]="!tooltipValue"></span>
  </button>
  <button type="button" class="btn btn-sm btn-link btn-edit-aide" title="Editer l'aide" *ngIf="isAdminAide()" (click)="editAide($event)">
    <span class="fa fa-pencil fa-question-circle-special" aria-hidden="true"></span>
  </button>
</div>
